import { Navigate, useParams } from 'react-router-dom'
import RoleFormPage from '../RoleFormPage/RoleFormPage'

export default function RoleEditPage() {
  const { roleId } = useParams()

  if (!roleId) {
    return <Navigate to="/roles/active" replace />
  }

  return <RoleFormPage mode="edit" roleId={roleId} />
}
